module.exports = __webpack_public_path__ + "img/8coin.1d26a848.png";